import React, { useEffect, useState } from "react";
import axios from "axios";
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import Section from '../Section';
import FeaturesSectionStyle2 from '../Section/FeaturesSection/FeaturesSectionStyle2';
import FunFactSection from '../Section/FunFactSection';
import TeamSection from '../Section/TeamSection';
import { pageTitle } from '../../helpers/PageTitle';
import First from "../Images/First.png";
import funfact from "../Images/funfact.jpeg";
import banner_bg from "../Images/banner_bg.svg";
import clinic from "../Images/clinic.webp";
import teamwork from "../Images/teamwork.svg"
import ctabg from "../Images/home_1/ctabg.svg"
import DepartmentSection from '../Section/DepartmentSection';
import bg3 from "../Images/bg/bg3.jpg";
import a23 from "../Images/a23.jpg"
import AwardSection from '../Section/AwardSection';
import BrandsSection from '../Section/BrandsSection';
import BannerSectionStyle2 from '../Section/BannerSection/BannerSectionStyle2';
import constants from "../../GlobalConstants";
import { checkEmpty, headerData } from "../../GenericFunctions";
import Carousal from "../../Carousal";
import MednaBrand from "../../config/MednaBrand";

const featureListData = [
  {
    iconSrc: '/images/home_1/compassion.svg',
    title: 'Built in UAE. Designed for the Future of Healthcare. ',
    subTitle: `
    <ul>
      <li>Designed specifically for the UAE healthcare Eco-System</li>
      <li>Built with insurance & TPA workflows in mind</li>
      <li>Supports modern interoperability standards (HL7 / FHIR readiness)</li>
      <li>Secure, on-premise deployment options</li>
      <li>Cost-effective alternative to large international systems</li>
      <li>Local implementation and support mindset</li>
      'Trusted by healthcare providers across UAE, from single clinics to multispecialty 
hospitals.'
    </ul>
  `,
    iconUrl: 'images/icons/professional.svg',
  },
];

const funFactData = [
  { number: '15+', title: 'Years of experience' },
  { number: '1.6 Cr', title: 'Patient Registration' },
  { number: '700000+', title: 'Transactions per day.' },
  { number: '5+', title: 'Countries Customers' },
  { number: '300+', title: 'Hospitals,Diagnostic Centers and Pharmacies Customers' },
];

const galleryData = [
  { imgUrl: process.env.PUBLIC_URL + '/images/about/flowchart.jpg' },
];

const departmentData1 = [
  {
    title: 'Paperless Operations ',
    iconUrl: process.env.PUBLIC_URL + '/images/home_1/paperless.png',
  },
  {
    title: 'Unified Patient Data ',
    iconUrl:process.env.PUBLIC_URL + '/images/home_1/patientdata.png',
  },
  {
    title: 'Automated Workflows',
    iconUrl: process.env.PUBLIC_URL + '/images/home_1/automated.png',
  },
  {
    title: 'Real-Time Analytics',
    iconUrl: process.env.PUBLIC_URL + '/images/home_1/realtime.png',
  },
];

const awardData2 = [
  {
    title: "* Hospital Management",
    subTitle:
      'A Hospital Management Software (HMS) streamlines operations by digitizing and automating' +
      ' tasks like patient registration, appointment scheduling, billing, and medical records, thereby ' +
      'improving efficiency and patient care quality.,',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: "* Clinic & Polyclinic",
    subTitle:
      'Clinic and polyclinic management software is an integrated solution designed to streamline' +
      'all administrative, clinical, and financial operations of healthcare facilities.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: "* Laboratory & Diagnostics",
    subTitle:
      'Laboratory & Diagnostics management software is a digital solution designed to automate' +
      'and streamline a labs entire workflow from patient registration and sample tracking to report' +
      'generation and billing.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: "* Pharmacy & Inventory",
    subTitle:
      'Pharmacy & Inventory management software automates the entire medication workflow,' +
      'from purchasing and stocking to billing and dispensing, thereby improving efficiency' +
      ' and ensuring regulatory compliance.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: "* Finance & Accounting ",
    subTitle:
      ' Finance & Accounting management software automates the recording, processing, and reporting' +
      ' of financial transactions to streamline operations and ensure compliance.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: "* Analytics & Business Intelligence",
    subTitle:
      'Analytics & Business Intelligence (BI) software helps organizations collect and analyze large' +
      ' amounts of data to uncover meaningful patterns and trends.',
    iconUrl: 'images/icons/award.svg',
  },
];

const brandData = (clientList) => {
  console.log("clientList", clientList);

  if (clientList && clientList.length > 0) {
    clientList = clientList.filter(fItem => (!checkEmpty(fItem.logo)))
    clientList.forEach(el => {
      el.imgUrl = el.logo
      el.imgAlt = 'Brand'
    })
    return clientList.map((item) => ({
      imgUrl: item.imgUrl,
      imgAlt: item.imgAlt || "Brand",
    }));
  }

  // // fallback default data
  // return [
  //   { imgUrl: 'images/brand_1.png', imgAlt: 'Brand' },
  //   { imgUrl: 'images/brand_2.png', imgAlt: 'Brand' },
  //   { imgUrl: 'images/brand_3.png', imgAlt: 'Brand' },
  //   { imgUrl: 'images/brand_4.png', imgAlt: 'Brand' },
  //   { imgUrl: 'images/brand_5.png', imgAlt: 'Brand' },
  //   { imgUrl: 'images/brand_6.png', imgAlt: 'Brand' },
  //   { imgUrl: 'images/brand_7.png', imgAlt: 'Brand' },
  //   { imgUrl: 'images/brand_8.png', imgAlt: 'Brand' },
  // ];
};

export default function HomeMain() {
  const [clientList, setClientList] = useState([]);
  useEffect(() => {
    const data = {
      loginDataVo: {
        master: 'L',
        config1: 'X1',
        language: 'EN',
        countryID: 'IN',
        getDetails: true,
        popularList: true,
        clientUrl: "docchoice.com",
      }
    };
    axios.post(constants.webServiceURL + "/DocChoiceWebServices/userManagement/getClientPortalList",
      data, { headerData }).then((response) => {
        setClientList(response.data.locationDetailsList);
      })
      .catch((error) => {
        console.error("API error:", error);
      });
  }, []);

  pageTitle('HomeMain');
  return (
    <>
      <BannerSectionStyle3
        bgUrl={banner_bg}
        imgUrl={First}
        title=" UAE’s Most Comprehensive<br />Healthcare ERP Solution"
        subTitle="One unified system for hospitals, clinics, and diagnostics — 
        managing care, data, and operations with intelligence."
      />
      <Section topMd={150} topLg={120} topXl={100}>
        <FeaturesSectionStyle2
          sectionTitle="Why Medna Data Systems"
          imgUrl={clinic} height='75%'
          iconUrl={teamwork}
          data={featureListData}
        />
      </Section>
      <Section >
        <AwardSection sectionTitle="A Complete Healthcare ERP Suite — All in One Platform "
          bgUrl={ctabg}
          imgUrl={ctabg}
          data={awardData2} />
      </Section>
      <Section topMd={60} topLg={50} topXl={40}>
        <DepartmentSection
          sectionTitle="Key Benefits"
          bgUrl={bg3}
          data={departmentData1}
          className="cs_key_benefits_section"
        />
      </Section>
      <Section topMd={150} topLg={120} topXl={100}>
        <FunFactSection
          bgUrl={funfact}
          data={funFactData}
        />
      </Section>
      <Section topMd={150} topLg={120} topXl={100}>
        <TeamSection
          sectionTitle="Integration and Compliance"
          sectionTitleUp="Interoperable,Secure and Reliable"
          data={galleryData}
        />
      </Section>
      {/* <Section >
        <GallerySection
          sectionTitle="Integration and Compliance"
          sectionTitleUp="Flow Chart showing details of Hospital , Labs, Pharmacy and Clinic
           workflow on unified platform"
          data={galleryData}
          imageUrl={flowchart}
        />
      </Section> */}
      <Section topMd={60} topLg={50} topXl={40} bottomMd={20} bottomLg={15} bottomXl={10}>
        <div style={{ textAlign: 'center', fontSize: '48px', fontWeight: '600', color: MednaBrand.colors.primary }}>
          PARTNERS & CLIENTS </div>
        <div style={{
          textAlign: 'center', fontSize: '24px', fontWeight: '600', color: MednaBrand.colors.accent, padding: '30px 0 80px'
        }}>
          Trusted by Healthcare Providers Across the Region </div>
        {/* <BrandsSection data={brandData(clientList)} /> */}
        <Carousal clientList={clientList} />


      </Section>
      <Section topMd={60} topLg={50} topXl={40} bottomMd={20} bottomLg={15} bottomXl={10}>
        <BannerSectionStyle2
          bgUrl={a23}
          title="Don't Let Your Hospital <br />Take a Backseat!"
          subTitle="Schedule an demo with one of our experienced <br />professionals today!"
        />
      </Section>
    </>
  );
}
